import LeftHeader from './LeftHeader';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import ArrowNext from './shared/ArrowNext';
import ArrrowPrev from './shared/ArrrowPrev';
import useStore from '../store/store';
import { useDateChoiceData } from '../hooks/useDateChoiceData';
import CalendarMonthSlide from './shared/CalendarMonthSlide';
import CalendarLegend from './shared/CalendarLegend';

const DateChoice = () => {
  const { setArrivalDate, arrivalDate, rooms } = useStore();
  const { dates, allowedLengths, discounts } = useDateChoiceData(rooms);

  const handleClickOnDate = (item) => {
    setArrivalDate(item.date);
  };

  return (
    <>
      <LeftHeader isBtnDisabled={arrivalDate === null} />
      <div className='main__wrapper main__wrapper--dates'>
        <div className='dates_swiper'>
          <Swiper
            className='dates_swiper__container'
            modules={[Navigation]}
            slidesPerView={window.innerWidth < 768 ? 1 : 3}
            spaceBetween={window.innerWidth < 768 ? 0 : 16}
          >
            <ArrrowPrev />
            {Object.entries(dates).map(([key, items]) => {
              const [year, month] = key.split('-');
              return (
                <SwiperSlide key={key}>
                  <CalendarMonthSlide
                    year={year}
                    month={month}
                    items={items}
                    allowedLengths={allowedLengths}
                    arrivalDate={arrivalDate}
                    discounts={discounts}
                    onDateClick={handleClickOnDate}
                  />
                </SwiperSlide>
              );
            })}
            <ArrowNext />
          </Swiper>
        </div>
        <CalendarLegend />
      </div>
    </>
  );
};

export default DateChoice;
